import gql from 'graphql-tag'

export const QUERY_GET_VOUCHERS = gql`
  query PointsVouchers($page: Int!, $pageSize: Int!, $sortDirection: [SortDirection!], $sort: [String!], $status: [String!], $search: String) {
    pointsVouchers(page: $page, pageSize: $pageSize, sortDirection: $sortDirection, sort: $sort, status: $status, search: $search) {
      items {
        title
        type
        _id
        description
        money
        image
        product_description
        points
        expires_in_days
        initial_date
        final_date
        draft
        rescue_limit
        user_limit
        units
        status
        updated_at
        remaining_rescue_limit
      }
      records
      page
    }
  }
`

export const QUERY_GET_VOUCHERS_METRICS = gql`
  query PointsVouchersMetrics {
    pointsVouchersMetrics {
      total_users_vouchers_activated
      total_users_vouchers_activated_percentage
      total_user_points
      total_user_with_points
      total_vouchers_active
      total_vouchers_active_discount
      total_vouchers_active_product
      total_vouchers_consumed
      total_vouchers_consumed_points
    }
  }
`

export const QUERY_GET_VOUCHER_BY_ID = gql`
  query PointsVoucher($id: ID!) {
    pointsVoucher(_id: $id) {
      _id
      title
      type
      description
      money
      image
      product_description
      points
      expires_in_days
      initial_date
      final_date
      draft
      rescue_limit
      user_limit
      units
      status
      updated_at
      remaining_rescue_limit
    }
  }
`

export const QUERY_GET_USERS_TOTAL_POINTS = gql`
  query Users($search: String, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    users(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      users {
        document_no
        points {
          total
        }
      }
    }
  }
`

export const MUTATION_UPSERT_POINTS_VOUCHER = gql`
  mutation UpsertPointsVoucher($input: UpsertPointsVoucherInput!) {
    upsertPointsVoucher(input: $input) {
      _id
      message
    }
  }
`

export const MUTATION_DELETE_VOUCHER = gql`
  mutation DeleteVoucher($id: ID!) {
    deleteVoucher(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_CLONE_VOUCHER = gql`
  mutation CloneVoucher($id: ID!) {
    cloneVoucher(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_FINALIZE_VOUCHER = gql`
  mutation FinalizeVoucher($id: ID!) {
    finalizeVoucher(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_UNSCHEDULED_VOUCHER = gql`
  mutation UnscheduleVoucher($id: ID!) {
    unscheduleVoucher(_id: $id) {
      _id
      message
    }
  }
`

export const QUERY_GET_VOUCHERS_ACTIVE = gql`
  query ActivatedVouchers(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $units: [ID]
    $units_configuration: [UnitConfigurationInput]
  ) {
    voucherInstances: activatedVouchers(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      units: $units
      units_configuration: $units_configuration
    ) {
      records
      page
      voucherInstances {
        _id
        user {
          _id
          document_no
          name
        }
        unit {
          _id
          id_erp
          name
        }
        money
        points
        activated_at
        consumed_at
        returned_at
      }
    }
  }
`

export const QUERY_GET_VOUCHERS_CONSUMED = gql`
  query ConsumedVouchers(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $initialDate: String
    $finalDate: String
    $units: [ID]
    $units_configuration: [UnitConfigurationInput]
  ) {
    voucherInstances: consumedVouchers(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
    ) {
      records
      page
      voucherInstances {
        _id
        user {
          _id
          document_no
          name
        }
        unit {
          _id
          id_erp
          name
        }
        money
        points
        activated_at
        consumed_at
        returned_at
      }
    }
  }
`
export const QUERY_GET_VOUCHERS_HISTORY = gql`
  query PointsVoucherHistory(
    $page: Int!
    $pageSize: Int!
    $pointsVoucherHistoryType: PointsVoucherHistoryType!
    $sort: [String!]
    $search: String
    $sortDirection: [SortDirection!]
    $initialDate: DateTime
    $finalDate: DateTime
    $units: [ID!]
  ) {
    pointsVoucherHistory(
      page: $page
      pageSize: $pageSize
      pointsVoucherHistoryType: $pointsVoucherHistoryType
      sort: $sort
      search: $search
      sortDirection: $sortDirection
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
    ) {
      items {
        consumer_document_no
        consumer_name
        money
        product_description
        date
        points
        unit {
          name
          _id
          id_erp
        }
      }
      records
      page
    }
  }
`

export const QUERY_GET_CLIENTS_CANT_ACCUMULATE_POINTS = gql`
  query UsersBlockedPoints($page: Int!, $pageSize: Int!, $search: String, $sort: [String!], $sortDirection: [SortDirection!]) {
    usersBlockedPoints(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      items {
        _id
        name
        created_at
        document_no
      }
    }
  }
`

export const QUERY_GET_PURCHASES_UNCREDITED_POINTS = gql`
  query PurchasesUncreditedPoints($page: Int!, $pageSize: Int!, $search: String, $sort: [String!], $sortDirection: [SortDirection!]) {
    purchasesUncreditedPoints(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      items {
        id
        name
        document_no
        purchase_date
        total_purchases
        purchases_over_limit
        uncredited_points
      }
    }
  }
`

export const QUERY_POINTS_BLOCKS_CONFIGURATION = gql`
  query PointsDiscountsBlocksConfiguration {
    pointsDiscountsBlocksConfiguration {
      black_list {
        active
      }
      coupons_limit {
        active
        limit_per_day
      }
    }
  }
`

export const MUTATION_UNLOCK_USER_POINTS = gql`
  mutation UnlockUserPoints($id: ID!) {
    unlockUserPoints(_id: $id) {
      success
      message
    }
  }
`

export const TIMELINE_EXPIRED_POINTS_METRICS = gql`
  query TimelinePointsMetrics($groupBy: MetricGranularity, $filters: [PointsFilter!]!) {
    timelinePointsMetrics(groupBy: $groupBy, filters: $filters) {
      data {
        label
        consumedPointsMetric
        acquiredPointsMetric
        expiredPointsMetric
      }
    }
  }
`

export const TIMELINE_FUTURE_POINTS_METRICS = gql`
  query FuturePointsExpirationsMetric($groupBy: MetricGranularity, $filters: [PointsFilter!]!) {
    futurePointsExpirationsMetric(groupBy: $groupBy, filters: $filters) {
      data {
        label
        futurePointsExpirationsMetric
      }
    }
  }
`

export const QUERY_GET_POINTS_USER_LOCKS = gql`
  query PointsUserLocks($page: Int!, $pageSize: Int!, $search: String, $sort: [String!], $sortDirection: [SortDirection!]) {
    pointsUserLocks(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      items {
        locked_value
        transaction_id
        consumer_document_no
        consumer_name
      }
      records
      page
    }
  }
`

export const MUTATION_RELEASE_POINTS_USER_LOCK = gql`
  mutation ReleasePointsUserLock($documentNo: String!) {
    releasePointsUserLock(document_no: $documentNo) {
      success
      message
    }
  }
`

export const MUTATION_UPDATE_POINTS_BLOCKS_CONFIGURATION = gql`
  mutation UpdatePointsDiscountsBlocksConfiguration($blackList: InputPointsDiscountsBlocksBlackList, $couponsLimit: InputPointsDiscountsBlocksCouponsLimit) {
    updatePointsDiscountsBlocksConfiguration(black_list: $blackList, coupons_limit: $couponsLimit)
  }
`

export const MUTATION_RESEND_ASYNC_JOB = gql`
  mutation CreatePointsReport($emails: [String!]!, $fileFormat: FileFormatType) {
    createPointsReport(emails: $emails, fileFormat: $fileFormat) {
      id
      payload {
        emails
        fileFormat
      }
      state
    }
  }
`

export const MUTATION_EXPORT_CONSUMED_VOUCHERS_REPORT = gql`
  mutation CreateConsumedVouchersReport(
    $emails: [String!]!
    $final_date: String
    $initial_date: String
    $units: [String!]
    $units_configuration: [UnitConfigurationInput!]
    $fileFormat: FileFormatType
  ) {
    createConsumedVouchersReport(
      emails: $emails
      initial_date: $initial_date
      final_date: $final_date
      units: $units
      units_configuration: $units_configuration
      fileFormat: $fileFormat
    ) {
      id
      payload {
        emails
        fileFormat
      }
      state
    }
  }
`
